import { Badge, BadgeProps } from '@shopify/polaris';
import { ConnectBadgeStyled } from './styled';

const ConnectBadge = (props: BadgeProps) => {
  return (
    <ConnectBadgeStyled>
      <div className="connect-line"></div>
      <Badge {...props} />
      <div className="connect-line"></div>
    </ConnectBadgeStyled>
  );
};

export default ConnectBadge;
